module.exports = __webpack_public_path__ + "img/cover-sirius-mob.5c6ffdab.png";